"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const ArrowLeftIcon_1 = __importDefault(require("./ArrowLeftIcon"));
const ArrowRightIcon_1 = __importDefault(require("./ArrowRightIcon"));
const ChartIcon_1 = __importDefault(require("./ChartIcon"));
const ChatIcon_1 = __importDefault(require("./ChatIcon"));
const CheckIcon_1 = __importDefault(require("./CheckIcon"));
const ChevronDownIcon_1 = __importDefault(require("./ChevronDownIcon"));
const ChevronRightIcon_1 = __importDefault(require("./ChevronRightIcon"));
const CircleChartIcon_1 = __importDefault(require("./CircleChartIcon"));
const CircleCheckIcon_1 = __importDefault(require("./CircleCheckIcon"));
const CircleExclamationIcon_1 = __importDefault(require("./CircleExclamationIcon"));
const CircleFileCheckIcon_1 = __importDefault(require("./CircleFileCheckIcon"));
const CircleHandIcon_1 = __importDefault(require("./CircleHandIcon"));
const CirclePuzzleIcon_1 = __importDefault(require("./CirclePuzzleIcon"));
const CircleSignatureIcon_1 = __importDefault(require("./CircleSignatureIcon"));
const CircleStarIcon_1 = __importDefault(require("./CircleStarIcon"));
const CircleUserIcon_1 = __importDefault(require("./CircleUserIcon"));
const CloseIcon_1 = __importDefault(require("./CloseIcon"));
const CsvFileIcon_1 = __importDefault(require("./CsvFileIcon"));
const PdfIcon_1 = __importDefault(require("./PdfIcon"));
const DefaultFileIcon_1 = __importDefault(require("./DefaultFileIcon"));
const DownloadIcon_1 = __importDefault(require("./DownloadIcon"));
const ExcelFileIcon_1 = __importDefault(require("./ExcelFileIcon"));
const ExternalLinkIcon_1 = __importDefault(require("./ExternalLinkIcon"));
const FileIcon_1 = __importDefault(require("./FileIcon"));
const FolderIcon_1 = __importDefault(require("./FolderIcon"));
const InfoIcon_1 = __importDefault(require("./InfoIcon"));
const Hum_1 = __importDefault(require("./Hum"));
const HumConnectErrorIcon_1 = __importDefault(require("./HumConnectErrorIcon"));
const MiniArchiveBoxIcon_1 = __importDefault(require("./MiniArchiveBoxIcon"));
const MiniArchiveBoxXMarkIcon_1 = __importDefault(require("./MiniArchiveBoxXMarkIcon"));
const HumConnectIcon_1 = __importDefault(require("./HumConnectIcon"));
const MoneyIcon_1 = __importDefault(require("./MoneyIcon"));
const NoteIcon_1 = __importDefault(require("./NoteIcon"));
const NotificationStarIcon_1 = __importDefault(require("./NotificationStarIcon"));
const Padlock_1 = __importDefault(require("./Padlock"));
const RefreshIcon_1 = __importDefault(require("./RefreshIcon"));
const SearchIcon_1 = __importDefault(require("./SearchIcon"));
const TripleDotIcon_1 = __importDefault(require("./TripleDotIcon"));
const UserIcon_1 = __importDefault(require("./UserIcon"));
const VerifyEmail_1 = __importDefault(require("./VerifyEmail"));
const FinancialGrowth_1 = __importDefault(require("./FinancialGrowth"));
const UnsupportedCountry_1 = __importDefault(require("./UnsupportedCountry"));
const InvestorSignupStepOne_1 = __importDefault(require("./InvestorSignupStepOne"));
const InvestorSignupStepTwo_1 = __importDefault(require("./InvestorSignupStepTwo"));
const InvestorSignupStepThree_1 = __importDefault(require("./InvestorSignupStepThree"));
const RingOnIcon_1 = __importDefault(require("./RingOnIcon"));
const RingOffIcon_1 = __importDefault(require("./RingOffIcon"));
const BuildingIcon_1 = __importDefault(require("./BuildingIcon"));
const ClearbooksIcon_1 = __importDefault(require("./connectors/ClearbooksIcon"));
const ExactIcon_1 = __importDefault(require("./connectors/ExactIcon"));
const FreeAgentIcon_1 = __importDefault(require("./connectors/FreeAgentIcon"));
const FreshbooksIcon_1 = __importDefault(require("./connectors/FreshbooksIcon"));
const KashFlowIcon_1 = __importDefault(require("./connectors/KashFlowIcon"));
const KashooIcon_1 = __importDefault(require("./connectors/KashooIcon"));
const MDynamicsIcon_1 = __importDefault(require("./connectors/MDynamicsIcon"));
const MyobIcon_1 = __importDefault(require("./connectors/MyobIcon"));
const NetsuiteIcon_1 = __importDefault(require("./connectors/NetsuiteIcon"));
const PandleIcon_1 = __importDefault(require("./connectors/PandleIcon"));
const QuickbooksIcon_1 = __importDefault(require("./connectors/QuickbooksIcon"));
const SageIcon_1 = __importDefault(require("./connectors/SageIcon"));
const WaveIcon_1 = __importDefault(require("./connectors/WaveIcon"));
const XeroIcon_1 = __importDefault(require("./connectors/XeroIcon"));
const GraphImage_1 = __importDefault(require("./GraphImage"));
const Icon = ({ src, width = '24', height = '24', className, onClick, }) => (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
    react_1.default.createElement(react_1.default.Suspense, { fallback: null },
        react_1.default.createElement("img", { src: src, width: width, height: height, className: className, alt: "" }))));
exports.Icon = Icon;
exports.Icon.ArrowLeft = ArrowLeftIcon_1.default;
exports.Icon.ArrowRight = ArrowRightIcon_1.default;
exports.Icon.Chart = ChartIcon_1.default;
exports.Icon.Chat = ChatIcon_1.default;
exports.Icon.Check = CheckIcon_1.default;
exports.Icon.ChevronDown = ChevronDownIcon_1.default;
exports.Icon.ChevronRight = ChevronRightIcon_1.default;
exports.Icon.CircleChart = CircleChartIcon_1.default;
exports.Icon.CircleCheck = CircleCheckIcon_1.default;
exports.Icon.CircleExclamation = CircleExclamationIcon_1.default;
exports.Icon.CircleFileCheck = CircleFileCheckIcon_1.default;
exports.Icon.CircleHand = CircleHandIcon_1.default;
exports.Icon.CirclePuzzle = CirclePuzzleIcon_1.default;
exports.Icon.CircleSignature = CircleSignatureIcon_1.default;
exports.Icon.CircleStar = CircleStarIcon_1.default;
exports.Icon.CircleUser = CircleUserIcon_1.default;
exports.Icon.Close = CloseIcon_1.default;
exports.Icon.CsvFile = CsvFileIcon_1.default;
exports.Icon.DefaultFile = DefaultFileIcon_1.default;
exports.Icon.Download = DownloadIcon_1.default;
exports.Icon.ExcelFile = ExcelFileIcon_1.default;
exports.Icon.PdfIcon = PdfIcon_1.default;
exports.Icon.ExternalLink = ExternalLinkIcon_1.default;
exports.Icon.File = FileIcon_1.default;
exports.Icon.Folder = FolderIcon_1.default;
exports.Icon.Hum = Hum_1.default;
exports.Icon.HumConnect = HumConnectIcon_1.default;
exports.Icon.HumConnectError = HumConnectErrorIcon_1.default;
exports.Icon.Info = InfoIcon_1.default;
exports.Icon.MiniArchiveBox = MiniArchiveBoxIcon_1.default;
exports.Icon.MiniArchiveBoxXMark = MiniArchiveBoxXMarkIcon_1.default;
exports.Icon.Money = MoneyIcon_1.default;
exports.Icon.Note = NoteIcon_1.default;
exports.Icon.NotificationStar = NotificationStarIcon_1.default;
exports.Icon.Padlock = Padlock_1.default;
exports.Icon.Refresh = RefreshIcon_1.default;
exports.Icon.Search = SearchIcon_1.default;
exports.Icon.TripleDot = TripleDotIcon_1.default;
exports.Icon.User = UserIcon_1.default;
exports.Icon.VerifyEmail = VerifyEmail_1.default;
exports.Icon.FinancialGrowth = FinancialGrowth_1.default;
exports.Icon.UnsupportedCountry = UnsupportedCountry_1.default;
exports.Icon.InvestorSignupStepOne = InvestorSignupStepOne_1.default;
exports.Icon.InvestorSignupStepTwo = InvestorSignupStepTwo_1.default;
exports.Icon.InvestorSignupStepThree = InvestorSignupStepThree_1.default;
exports.Icon.GrphImage = GraphImage_1.default;
exports.Icon.RingOn = RingOnIcon_1.default;
exports.Icon.RingOff = RingOffIcon_1.default;
exports.Icon.Building = BuildingIcon_1.default;
//Connectors
exports.Icon.Clearbooks = ClearbooksIcon_1.default;
exports.Icon.Exact = ExactIcon_1.default;
exports.Icon.FreeAgent = FreeAgentIcon_1.default;
exports.Icon.Freshbooks = FreshbooksIcon_1.default;
exports.Icon.KashFlow = KashFlowIcon_1.default;
exports.Icon.Kashoo = KashooIcon_1.default;
exports.Icon.MDynamics = MDynamicsIcon_1.default;
exports.Icon.Myob = MyobIcon_1.default;
exports.Icon.Netsuite = NetsuiteIcon_1.default;
exports.Icon.Pandle = PandleIcon_1.default;
exports.Icon.Quickbooks = QuickbooksIcon_1.default;
exports.Icon.Sage = SageIcon_1.default;
exports.Icon.Wave = WaveIcon_1.default;
exports.Icon.Xero = XeroIcon_1.default;
//# sourceMappingURL=Icon.js.map